var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":_vm.clickEvent}},[(_vm.showImage)?_c('i',{staticClass:"material-symbols-outlined col-2"},[_vm._v("exit_to_app")]):_vm._e(),_c('span',{staticClass:"col-10 label"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }